<template>
    <section class="new-modals">
        <EditTask v-if="$store.getters.GET_ACTIVE_MODAL === 'EditTask'"
                  :task="$store.getters.GET_ACTIVE_MODAL_PROPS"/>

        <UserInteraction
                v-if="$store.getters.GET_ACTIVE_MODAL === 'UserInteraction'"
                @userAcceptedAction="userAcceptedAction"
                :passedProps="$store.getters.GET_ACTIVE_MODAL_PROPS">
        </UserInteraction>

        <SuperAdminUserInteraction
            v-if="$store.getters.GET_ACTIVE_MODAL === 'SuperAdminUserInteraction'"
            @userAcceptedAction="userAcceptedAction"
            :passedProps="$store.getters.GET_ACTIVE_MODAL_PROPS">
        </SuperAdminUserInteraction>

        <SuperAdminCustomForm
            v-if="$store.getters.GET_ACTIVE_MODAL === 'SuperAdminCustomForm'"
            :title="$store.getters.GET_ACTIVE_MODAL_PROPS.title"
            :languages="$store.getters.GET_ACTIVE_MODAL_PROPS.languages"
            :existingValue="$store.getters.GET_ACTIVE_MODAL_PROPS.existingValue"
            :buttonSettings="$store.getters.GET_ACTIVE_MODAL_PROPS.button"
            :fields="$store.getters.GET_ACTIVE_MODAL_PROPS.fields"
        />

        <SuperAdminImportForm
            v-if="$store.getters.GET_ACTIVE_MODAL === 'SuperAdminImportForm'"
            :title="$store.getters.GET_ACTIVE_MODAL_PROPS.title"
            :label="$store.getters.GET_ACTIVE_MODAL_PROPS.label"
            :labelInfo="$store.getters.GET_ACTIVE_MODAL_PROPS.labelInfo"
        />

        <SuperAdminAcceptModal
            v-if="$store.getters.GET_ACTIVE_MODAL === 'SuperAdminAcceptModal'"
            :confirmText="$store.getters.GET_ACTIVE_MODAL_PROPS.confirmText"
            :askForCheckmarkConfirm="$store.getters.GET_ACTIVE_MODAL_PROPS.askForCheckmarkConfirm"
            :isInformative="$store.getters.GET_ACTIVE_MODAL_PROPS.isInformative"
        />

        <AddRecipients
            v-if="$store.getters.GET_ACTIVE_MODAL === 'AddRecipients'"
            :emails="$store.getters.GET_ACTIVE_MODAL_PROPS.emails"
            :selectExistingEmails="$store.getters.GET_ACTIVE_MODAL_PROPS.selectExistingEmails"
            :addNewEmails="$store.getters.GET_ACTIVE_MODAL_PROPS.addNewEmails"
        />

        <AddRecipientsViaTextarea
            v-if="$store.getters.GET_ACTIVE_MODAL === 'AddRecipientsViaTextarea'"
        />

        <ConvertToFilter
            v-if="$store.getters.GET_ACTIVE_MODAL === 'ConvertToFilter'"
            :questionId="$store.getters.GET_ACTIVE_MODAL_PROPS.questionId"
            :filterId="$store.getters.GET_ACTIVE_MODAL_PROPS.filterId"
            :existingFilterName="$store.getters.GET_ACTIVE_MODAL_PROPS.existingFilterName"
        />

        <ManageFilters
            v-if="$store.getters.GET_ACTIVE_MODAL === 'ManageFilters'"
        />

        <Confirmation
            v-if="$store.getters.GET_ACTIVE_MODAL === 'Confirmation'"
            :title="$store.getters.GET_ACTIVE_MODAL_PROPS.title"
            :description="$store.getters.GET_ACTIVE_MODAL_PROPS.description"
            :decline="$store.getters.GET_ACTIVE_MODAL_PROPS.decline"
            :accept="$store.getters.GET_ACTIVE_MODAL_PROPS.accept"
        />

    </section>
</template>

<script>
    import UserInteraction from "./UserInteraction";
    import EditTask from "./action-plans/EditTask";
    import SuperAdminUserInteraction from "./SuperAdminUserInteraction";
    import SuperAdminCustomForm from "../superadmin/ux/SuperAdminCustomForm";
    import SuperAdminImportForm from "../superadmin/ux/SuperAdminImportForm";
    import SuperAdminAcceptModal from "../superadmin/ux/SuperAdminAcceptModal";
    import AddRecipients from "@/components/modals/invitiation-manager/AddRecipients";
    import AddRecipientsViaTextarea from "@/components/modals/invitiation-manager/AddRecipientsViaTextarea";
    import ConvertToFilter from "@/components/modals/results/ConvertToFilter";
    import ManageFilters from "@/components/modals/results/ManageFilters";
    import Confirmation from "@/components/modals/results/Confirmation";

    export default {
        name: "AllModalBase",
        components: {
            Confirmation,
            ManageFilters,
            ConvertToFilter,
            AddRecipients,
            AddRecipientsViaTextarea,
            SuperAdminAcceptModal,
            SuperAdminUserInteraction,
            UserInteraction,
            EditTask,
            SuperAdminCustomForm,
            SuperAdminImportForm
        },
        methods: {
            userAcceptedAction() {
                this.$store.commit('CLOSE_MODAL_ACCEPT');
            }
        }
    }
</script>

<style lang="scss">
    @include super-admin-modal;

    .new-modals {
        @include global-modal;
    }
</style>
